import { AxiosError } from "axios";
import { fetcher } from "@/shared/core-configs";
import { API } from "@/config";
import type { ApplicantInput } from "../types/Applicant";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { GET_APPLICANTS_FETCH_KEY } from "./useGetApplicants";

export const createApplicant = async (
  newApplicant: Partial<ApplicantInput>,
): Promise<ApplicantInput> => {
  const response = await fetcher.post(
    `${API.GESLUB}/productApplicant`,
    newApplicant,
  );
  return response.data;
};

export const useCreateApplicant = () => {
  const queryClient = useQueryClient();
  return useMutation<
    ApplicantInput,
    AxiosError<{ message: string }>,
    Partial<ApplicantInput>
  >({
    mutationFn: createApplicant,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [GET_APPLICANTS_FETCH_KEY],
      });
    },
    onError: (error) => {
      console.error("Error creating applicant:", error);
    },
  });
};
